import { render, staticRenderFns } from "./ForestCrawlRequestsView.vue?vue&type=template&id=b703e920&"
import script from "./ForestCrawlRequestsView.vue?vue&type=script&lang=js&"
export * from "./ForestCrawlRequestsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports